import React, { useEffect, useState } from "react";
import "./History.css";

const HistoryTableALL = React.memo(function HistoryTableALL({ Game_Icons, HistoryAllData, onClose }) {
    const [imageArray, setImageArray] = useState([]);
    const [reversedPayouts, setReversedPayouts] = useState([]);
    const cellSize = 40;
    const rows = 3;
    const cols = 5;
    const activeColor = "#47a59c"; // 🔹 Aqua-blue
    const inactiveColor = "#070707b4"; // 🔹 Dark
    const lineColor = "#e6c408ff"; // line inside selected
   const history = HistoryAllData || [];

    // console.log(HistoryAllData)

    const [openIndex, setOpenIndex] = useState(null);

    const toggleRow = (i) => {
        setOpenIndex(openIndex === i ? null : i);
    };
    // const iconsArr = Object.values(Game_Icons);

       const iconsArr = React.useMemo(
        () => Object.values(Game_Icons || {}),
        [Game_Icons]
    );

    // Create final grid 3x5

   const getSlotGrid = React.useCallback((linesCount) => {
        const grid = Array.from({ length: rows }, () => Array(cols).fill(null));
        for (let col = 0; col < cols; col++) {
            for (let row = 0; row < rows; row++) {
                grid[row][col] = iconsArr[linesCount[col][row]];
            }
        }
        return grid;
    }, [iconsArr]);

    useEffect(() => {
        console.log(HistoryAllData)
        if (!Game_Icons || Object.keys(Game_Icons).length === 0) {
            setImageArray([]);
            return;
        }

        // ✅ Build image array safely
        const icons = Object.keys(Game_Icons).map((key, index) => ({
            id: index + 1,
            name: key,
            url: Game_Icons[key],
            title: `Icon ${index + 1}`,
            description: `Description for ${key}`,
        }));

        setImageArray(icons);

        // ✅ Setup payout map


        // console.log("✅ imageArray:", icons);
    }, [Game_Icons]);

    // ✅ Safety check for rendering
    if (!Game_Icons || imageArray.length === 0) {
        return <p>No icons found.</p>;
    }


    return (
        <div className="main-History_ALL" >
            <button className="closebtn_HL" onClick={onClose}>
                x
            </button>
            <div className="posn_top_HAL">
                <h1 className="Main_head_HAL">HISTORY TABLE</h1>
                <p className="History_Line"></p>
            </div>
            <div className="history-wrapper_HAL">
                <table className="history-table_HAL">
                    <thead>
                        <tr>
                            {history[0]?.HistoryKeyData?.map((header, idx) => (
                                <th key={idx}>{header.id}</th>
                            ))}
                            <th></th>
                        </tr>
                    </thead>

                    <tbody>
                        {history?.map((row, i) => {
                            const slotGrid = getSlotGrid(row.SlotsGrid.board);

                            return (
                                <React.Fragment key={i}>

                                    {/* MAIN ROW --------------------------- */}
                                    <tr className="history-row_HAL" onClick={() => toggleRow(i)}>
                                        {row?.HistoryKeyData?.map((item, h) => (
                                            <td key={h}>
                                                {item.id === "Bet" || item.id === "Win" || item.id === "Bonus"
                                                    ? `₹${item.value}`
                                                    : item.value}
                                            </td>
                                        ))}
                                        <td>{openIndex === i ? "▲" : "▼"}</td>
                                    </tr>

                                    {/* EXPANDED ROW ----------------------- */}
                                    {openIndex === i && (
                                        <tr className="details-row">
                                            <td colSpan={row?.HistoryKeyData?.length + 1}>
                                                <div className="details-container">

                                                    {/* SLOT GRID ------------------------------------- */}
                                                    <div className="reel-container">
                                                        <h3 className="head3_text">Final Spin</h3>
                                                        <div className="reel-grid">
                                                            {slotGrid.map((rArr, r) =>
                                                                rArr.map((icon, c) => (
                                                                    <img
                                                                        key={`${r}-${c}`}
                                                                        src={icon}
                                                                        alt=""
                                                                        className="reel-symbol"
                                                                    />
                                                                ))
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* WINNING LINES -------------------------------- */}
                                                    <div className="lines-container">
                                                        <h3 className="head3_text">Winning Lines</h3>
                                                        <div className="lines-grid">
                                                            <div className="marg_top">
                                                                <div className="paylines-gridHAL">
                                                                    {row.SlotsGrid.winninglines.map((linePos, idx) => {
                                                                        const points = linePos
                                                                            .map((r, c) => {
                                                                                const x = c * cellSize + cellSize / 2;
                                                                                const y = r * cellSize + cellSize / 2;
                                                                                return `${x},${y}`;
                                                                            })
                                                                            .join(" ");

                                                                        return (
                                                                            <div key={idx} className="line-boxHAL">
                                                                                <div className="line-numHAL">{idx + 1}</div>

                                                                                <svg
                                                                                    width={cellSize * cols}
                                                                                    height={cellSize * rows}
                                                                                    className="payline-svgHAL"
                                                                                >
                                                                                    {/** grid background */}
                                                                                    {[...Array(rows)].map((_, r) =>
                                                                                        [...Array(cols)].map((_, c) => {
                                                                                            const active = linePos[c] === r;
                                                                                            return (
                                                                                                <rect
                                                                                                    key={`${r}-${c}`}
                                                                                                    x={c * cellSize}
                                                                                                    y={r * cellSize}
                                                                                                    width={cellSize}
                                                                                                    height={cellSize}
                                                                                                    fill={
                                                                                                        active
                                                                                                            ? activeColor
                                                                                                            : inactiveColor
                                                                                                    }
                                                                                                    stroke="#333"
                                                                                                />
                                                                                            );
                                                                                        })
                                                                                    )}

                                                                                    {/* connecting line */}
                                                                                    <polyline
                                                                                        points={points}
                                                                                        fill="none"
                                                                                        stroke={lineColor}
                                                                                        strokeWidth="4"
                                                                                        strokeLinecap="round"
                                                                                        strokeLinejoin="round"
                                                                                    />

                                                                                    {/* highlight dots */}
                                                                                    {linePos.map((r, c) => (
                                                                                        <circle
                                                                                            key={c}
                                                                                            cx={c * cellSize + cellSize / 2}
                                                                                            cy={r * cellSize + cellSize / 2}
                                                                                            r="2"
                                                                                            fill="#470461c7"
                                                                                            stroke={lineColor}
                                                                                        />
                                                                                    ))}
                                                                                </svg>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                    {
                        history.length == 0 && <div className="Hisitoy_No_Data"> <h5>No Data Found</h5></div>

                    }

                </table>

            </div>
        </div>
    );
})

export default HistoryTableALL;





